// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { color } from '@kintent/glide';

export const Wrapper = styled.main`
  grid-area: main;

  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 10rem 6rem 4rem 6rem;

  background-color: ${({ theme }) => color(theme.colorV2.system.gray, 100)};

  min-height: 100vh;

  & .notification-section-grid {
    display: grid;
    grid-template-areas: 'left-panel notification-content-panel';
    grid-template-columns: 260px 1fr;
    column-gap: 64px;

    height: 100%;
  }

  & h1 {
    font-weight: 600;
  }
`;

export const NotificationContentPanel = styled.section`
  grid-area: notification-content-panel;

  & .notification-item-section-container {
    .notification-item-section-label {
      padding-bottom: 16px;

      font-weight: 500;
      font-family: Lato;
    }
  }
`;

export const NotificationCard = styled.article`
  margin: 36px 0;

  &:first-of-type {
    margin-top: 0;
  }

  & .notification-item-card-description {
    font-weight: 500;
    font-family: Lato;
  }

  & .notification-item-card-detail-view-link {
    width: fit-content;
    padding-top: 16px;
  }
`;

export const Heading = styled.div`
  background-color: ${({ theme }) => color(theme.colorV2.system.gray, 50)};

  border: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 600)};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  display: flex;
  align-items: center;

  & .notification-item-tag-container,
  & .notification-item-timestamp-container {
    padding: 20px 24px;
    border-right: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 600)};
  }
`;

export const Body = styled.div`
  background-color: white;

  border: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 600)};
  border-top: none;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 20px 24px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;

  & .notification-item-title-copy {
    font-weight: 600;
  }

  & .notification-item-icon-button {
    border: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 50)};
    padding: 10px 12px;
  }
`;
